import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard, LoginComponent } from 'projects/shared/src/public-api';
import { HomeComponent } from './home/home.component';
import { MainViewComponent } from './main-view/main-view.component';
import { ConstructionSiteComponent } from './construction-site/construction-site.component';
import { ConstructionDayReportOverviewComponent } from './construction-day-report-overview/construction-day-report-overview.component';
import { UserComponent } from './user/user.component';
import { AbsenceOverviewComponent } from './absence-overview/absence-overview.component';
import { HoursOverviewComponent } from './hours-overview/hours-overview.component';
import { CalendarComponent } from './calendar/calendar.component';
import { SettingsComponent } from './settings/settings.component';
import { MachineryOverviewComponent } from './machinery-overview/machinery-overview.component';
import { FilesComponent } from './files/files.component';

const routes: Routes = [
  { path: '', redirectTo: 'mainview', pathMatch: 'full' },
  {
    path: 'mainview',
    component: MainViewComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      {
        path: 'construction-sites',
        component: ConstructionSiteComponent,
      },
      {
        path: 'construction-day-report-overview',
        component: ConstructionDayReportOverviewComponent,
      },
      {
        path: 'user',
        component: UserComponent,
      },
      {
        path: 'absence-overview',
        component: AbsenceOverviewComponent,
      },
      {
        path: 'hours-overview',
        component: HoursOverviewComponent,
      },
      {
        path: 'calendar',
        component: CalendarComponent,
      },
      {
        path: 'settings',
        component: SettingsComponent,
      },
      {
        path: 'machinery-overview',
        component: MachineryOverviewComponent,
      },
      {
        path: 'files',
        component: FilesComponent,
      },
    ],
    canActivate: [AuthGuard],
  },

  { path: 'login', component: LoginComponent },
  { path: '**', redirectTo: 'mainview', pathMatch: 'full' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
